import * as z from 'zod';
import { MONEY_ACCOUNT_TYPE } from 'src/features/moneyAccounts/utils/types';
import { CURRENCY } from 'src/types';
import { validationMessagesMap } from 'src/utils/messages';

export type MoneyAccountFormSchemaValues = z.infer<typeof moneyAccountFormSchema>;
export const moneyAccountFormSchema = z
    .object({
        name: z.string().nonempty(),
        type: z.enum(MONEY_ACCOUNT_TYPE),
        reference: z.string().nonempty(),
        currency: z.enum(CURRENCY),
        is_active: z.boolean(),
        iban: z.string().max(34).optional().nullable(),
        billing_entity: z.string().nonempty(),
    })
    .superRefine((data, ctx) => {
        if (data.type === MONEY_ACCOUNT_TYPE.BANK && !data.iban) {
            ctx.addIssue({
                path: ['iban'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
    });
